import { Envelope, WhatsappLogo, PaperPlaneTilt } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export function NotificationSettings({
  emailEnabled,
  setEmailEnabled,
  email,
  setEmail,
  notificationTime,
  setNotificationTime,
  whatsappEnabled,
  setWhatsappEnabled,
  whatsappNumber,
  setWhatsappNumber,
  onTestWhatsApp,
  isDark,
}) {
  const labelClass = `font-medium ${isDark ? "text-white" : "text-gray-900"}`;
  const subClass = `text-sm font-body ${isDark ? "text-gray-500" : "text-gray-400"}`;
  const fieldLabel = `text-sm font-medium ${isDark ? "text-gray-300" : "text-gray-700"}`;

  return (
    <div className="space-y-6">
      {/* Email */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Envelope size={24} className={isDark ? "text-gray-500" : "text-gray-400"} />
          <div>
            <p className={labelClass}>Email Notifications</p>
            <p className={subClass}>Receive daily opportunity alerts via email</p>
          </div>
        </div>
        <Switch checked={emailEnabled} onCheckedChange={setEmailEnabled} data-testid="email-toggle" />
      </div>

      {emailEnabled && (
        <div className="space-y-4 pl-9 animate-fade-in">
          <div>
            <Label htmlFor="email" className={fieldLabel}>Notification Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 rounded-lg"
              data-testid="email-input"
            />
          </div>
          <div>
            <Label htmlFor="time" className={fieldLabel}>Notification Time (UTC)</Label>
            <Select value={notificationTime} onValueChange={setNotificationTime}>
              <SelectTrigger className="mt-1 rounded-lg" data-testid="time-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="06:00">06:00 AM</SelectItem>
                <SelectItem value="08:00">08:00 AM</SelectItem>
                <SelectItem value="10:00">10:00 AM</SelectItem>
                <SelectItem value="12:00">12:00 PM</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      )}

      {/* WhatsApp */}
      <div className={`pt-4 border-t ${isDark ? "border-white/10" : "border-gray-200"}`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <WhatsappLogo size={24} className="text-green-500" />
            <div>
              <p className={labelClass}>WhatsApp Notifications</p>
              <p className={subClass}>Get daily alerts on WhatsApp (simulated)</p>
            </div>
          </div>
          <Switch checked={whatsappEnabled} onCheckedChange={setWhatsappEnabled} data-testid="whatsapp-toggle" />
        </div>

        {whatsappEnabled && (
          <div className="space-y-4 pl-9 mt-4 animate-fade-in">
            <div>
              <Label htmlFor="whatsapp" className={fieldLabel}>WhatsApp Number</Label>
              <Input
                id="whatsapp"
                type="tel"
                placeholder="+1234567890"
                value={whatsappNumber}
                onChange={(e) => setWhatsappNumber(e.target.value)}
                className="mt-1 rounded-lg"
                data-testid="whatsapp-input"
              />
              <p className={`text-xs mt-1 ${isDark ? "text-gray-600" : "text-gray-400"}`}>
                Include country code. Twilio integration coming soon.
              </p>
            </div>
            <Button
              onClick={onTestWhatsApp}
              variant="outline"
              className={`text-xs rounded-lg ${isDark ? "border-green-500/30 text-green-400 hover:bg-green-500/10" : "border-green-300 text-green-600 hover:bg-green-50"}`}
              data-testid="test-whatsapp-btn"
            >
              <PaperPlaneTilt size={14} className="mr-1" />
              Send Test (Simulated)
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
